/* eslint-disable */
import Vue from 'vue';
import ShardsVue from 'shards-vue';
// import Vuesax from 'vuesax'

// import 'vuesax/dist/vuesax.css' 
// Styles
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import '@/scss/shards-dashboards.scss';
import '@/assets/scss/date-range.scss';
import "@/css/MasterControl.css"
import 'sweetalert2/dist/sweetalert2.min.css';
import "./dist/components/components.bundle";
import "./dist/components/app.style.css";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-step-progress/dist/main.css';
import 'ant-design-vue/dist/antd.css';
import 'vue-ionicons/ionicons.scss';
import {
  BootstrapVue,
  IconsPlugin
} from 'bootstrap-vue'


// Core

import { AgGridVue } from "ag-grid-vue";

import App from './App.vue';
import router from './router';
import DataTable from './VAComponents/datatable/datatable';
import DataTableCollection from './VAComponents/datatable/datatable-collection';
import DataTableColumn from './VAComponents/datatable/datatable-column';
import DataTableCell from './VAComponents/datatable/datatable-cell';
import Paginator from './VAComponents/paginator/paginator';
import Checkbox from './VAComponents/toggles/checkbox';
import chip from './VAComponents/chip/chip';
import Drag from './directives/v-drag';
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
import Antd from 'ant-design-vue';
import AlertIcon from 'vue-ionicons/dist/ios-alert.vue'
import VueApexCharts from 'vue-apexcharts';
import $ from 'jquery';
import JsonExcel from 'vue-json-excel'
import XLSX from 'xlsx';
import StepProgress from 'vue-step-progress';

import steps from 'ant-design-vue';
// Layouts
import Default from '@/layouts/Default.vue';
import VueSweetalert2 from 'vue-sweetalert2';
import JsonCSV from 'vue-json-csv'
import { VueCsvImport } from 'vue-csv-import';

 

ShardsVue.install(Vue);
Vue.directive('drag', Drag);
Vue.component('default-layout', Default);

// Vue.use(Vuesax)
Vue.use(VueApexCharts)
Vue.use(axios, axios)
Vue.use(VueSweetalert2);
Vue.component('chip', chip)
Vue.component('XLSX', XLSX)
Vue.component('jquery', $)
Vue.component('Antd', Antd)
Vue.component('alert-icon', AlertIcon)
Vue.component('datatable', DataTable)
Vue.component('datatable-collection', DataTableCollection)
Vue.component('datatable-column', DataTableColumn)
Vue.component('datatable-cell', DataTableCell)
Vue.component('paginator', Paginator)
Vue.component('checkbox', Checkbox)
Vue.component('apexchart', VueApexCharts)
Vue.component('step-progress', StepProgress)
Vue.component('steps', steps)
Vue.component('downloadCsv', JsonCSV)
Vue.component('ag-grid-vue', AgGridVue)



Vue.component('VueCsvImport', VueCsvImport)
import { XlsCsvParser } from 'vue-xls-csv-parser';

Vue.component('XlsCsvParser', XlsCsvParser)



Vue.use(UploaderPlugin);
Vue.component('downloadExcel', JsonExcel);

//

import Toaster from 'v-toaster'

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'v-toaster/dist/v-toaster.css'

// optional set default imeout, the default is 10000 (10 seconds).
Vue.use(Toaster, {
  timeout: 3000
})
import 'vue-simple-suggest/dist/styles.css'
import VueSimpleSuggest from 'vue-simple-suggest';

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.component('vue-simple-suggest', VueSimpleSuggest)

// axios.defaults.baseURL = 'http://localhost/DevtoolAPI/';
 axios.defaults.baseURL = 'https://erptool.digitechniq.in/DevtoolAPI/';


Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
